var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"living clearfix"},[_c('negotiateLive',{ref:"livePage",attrs:{"isDateType":_vm.isType,"livingList":_vm.livingList},on:{"dateChange":_vm.getAgendaList,"toLivePath":_vm.toLivePath}}),_c('videoPlay',{ref:"videoPlay"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }